import React from 'react';
import PropTypes from 'prop-types';
import Moment from 'moment';
import PageTemplate from '../../templates/PageTemplate';
import Breadcrumbs from '../../atoms/Breadcrumbs';
// eslint-disable-next-line import/no-named-as-default
import OrderDetail from '../../organisms/OrderDetail';

class OrderDetails extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      date: null,
      time: '',
      status: null,
    };
    this.setDeliveryDate = this.setDeliveryDate.bind(this);
    this.setDeliveryTime = this.setDeliveryTime.bind(this);
    this.setDeliveryStatus = this.setDeliveryStatus.bind(this);
  }

  setDeliveryDate(x) {
    this.setState({ date: x }, () => {
    });
  }

  setDeliveryTime(x) {
    this.setState({ time: x });
  }

  setDeliveryStatus(x) {
    this.setState({ status: x });
  }

  buildTitle() {
    let title = '';

    if (this.state.status && this.state.date) {
      title += 'Your order';
      title += this.state.status === 'Delivered' ? ' has been delivered on ' : ' is expected ';
      title += Moment(this.state.date).isValid() ? Moment(this.state.date).format('ddd DD MMM') : '';
    }

    return title;
  }

  render() {
    const location = this.props.history.location.pathname.substr(1);
    return (
      <React.Fragment>
        <PageTemplate
          title={this.buildTitle()}
          subTitle={this.state.time ? `between ${this.state.time}` : ''}
        />
        <Breadcrumbs currentRoute={location} />
        <OrderDetail
          params={this.props.match.params}
          getDate={this.setDeliveryDate}
          getTime={this.setDeliveryTime}
          getStatus={this.setDeliveryStatus}
        />
      </React.Fragment>
    );
  }
}

OrderDetails.propTypes = {
  match: PropTypes.instanceOf(Object),
  history: PropTypes.instanceOf(Object),
};

OrderDetails.defaultProps = {
  match: '',
  history: '',
};

export default OrderDetails;



// WEBPACK FOOTER //
// src/components/pages/OrderDetails/index.jsx